import Vue from "vue";
import Router from "vue-router";
import store from "../store/index";
import i18n from "../locale/i18n.js";
import { browserTitle } from "../utils/utils.js";
const FormPage = () =>
  import( /* webpackChunkName: "pages" */ "../pages/FormPage.vue");
const Index = () =>
  import( /* webpackChunkName: "pages" */ "../pages/Index.vue");
const BookView = () =>
  import( /* webpackChunkName: "pages" */ "../pages/BookView.vue");
const ArticleView = () =>
  import( /* webpackChunkName: "pages" */ "../pages/ArticleView.vue");
const Create = () =>
  import( /* webpackChunkName: "pages" */ "../pages/CreateBook.vue");
const ArticleEdit = () =>
  import( /* webpackChunkName: "pages" */ "../pages/ArticleEdit.vue");
const HomePage = () =>
  import( /* webpackChunkName: "pages" */ "../pages/Home.vue");
const BookList = () =>
  import( /* webpackChunkName: "pages" */ "../components/book/BookList.vue");
const ArticleList = () =>
  import( /* webpackChunkName: "pages" */ "../components/article/ArticleList.vue");
const Profile = () =>
  import( /* webpackChunkName: "pages" */ "../pages/Profile.vue");
const DefaultPage = () =>
  import( /* webpackChunkName: "pages" */ "../pages/404.vue");
const CreateEvent = () => import( /* webpackChunkName: "event" */ '../pages/event/Event-Create.vue')
const EventSettings = () => import( /* webpackChunkName: "event" */ '../pages/event/Event-Setting.vue')
const EventList = () => import( /* webpackChunkName: "event" */ '../pages/event/Event-List.vue')
const EventView = () => import( /* webpackChunkName: "event" */ "../pages/event/Event-View.vue");
const Event = () => import( /* webpackChunkName: "event" */ "../pages/event/Index.vue");
const AdminIndex = () => import( /* webpackChunkName: "admin" */ "../admin/index.vue");


Vue.use(Router);

const routes = [
  // {
  //   path: "/",
  //   name: "Welcome",
  //   component: Welcome,
  //   meta: { auth: false, keepAlive: true }
  // },
  {
    path: "/",
    name: "Index",
    component: Index,
    meta: { auth: false, keepAlive: true }
  },
  {
    path: "/index",
    redirect: "/"
  },
  {
    path: "/login",
    name: "Login",
    component: FormPage,
    meta: { auth: false }
  },
  {
    path: "/reg",
    name: "Reg",
    component: FormPage,
    meta: { auth: false }
  },
  {
    path: "/create/",
    name: "Create",
    component: Create,
    meta: { auth: true }
  },
  {
    path: "/editBook/:bookId",
    name: "EditBook",
    component: Create,
    meta: { auth: true }
  },
  {
    path: "/@:username/:code/articleList",
    name: "BookView",
    component: BookView,
    meta: { auth: false, keepAlive: false }
  },
  {
    path: "/@:username/:code",
    name: "Book",
    component: BookView,
    meta: { auth: false, keepAlive: false }
  },
  {
    path: "/@:username/:code/addArticle",
    name: "AddArticle",
    component: ArticleEdit,
    meta: { auth: true, keepAlive: false, inEditor: true }
  },
  {
    path: "/home",
    component: HomePage,
    meta: { auth: true, keepAlive: false },
    children: [{
        path: "",
        component: BookList,
        name: "HomeDefault",
        props: {
          type: "created"
        },
        meta: { auth: true, keepAlive: false }
      },
      {
        path: "createdBook",
        component: BookList,
        name: "HomeCreatedBook",
        props: {
          type: "created"
        },
        meta: { auth: true, keepAlive: false }
      },
      {
        path: "favedBook",
        component: BookList,
        name: "HomeFavedBook",
        props: {
          type: "faved"
        },
        meta: { auth: true, keepAlive: false }
      },
      {
        path: "joinedBook",
        component: BookList,
        name: "HomeJoinedBook",
        props: {
          type: "joined"
        },
        meta: { auth: true, keepAlive: false }
      },
      {
        path: "createdArticle",
        component: ArticleList,
        name: "HomeCreatedArticle",
        props: {
          from: "created"
        },
        meta: { auth: true, keepAlive: false }
      },
      {
        path: "favedArticle",
        component: ArticleList,
        name: "HomeFavedArticle",
        props: {
          from: "faved"
        },
        meta: { auth: true, keepAlive: false }
      },
      {
        path: "draftArticle",
        component: ArticleList,
        name: "HomeDraftArticle",
        props: {
          from: "draft"
        },
        meta: { auth: true, keepAlive: false }
      }
    ]
  },
  {
    path: "/profile",
    name: "Setting",
    component: Profile,
    meta: { auth: true }
  },
  {
    path: "/profile/:type",
    name: "Profile",
    component: Profile,
    meta: { auth: true }
  },
  {
    path: "/activation/:email/:code",
    name: "EmailActivation",
    component: FormPage,
    meta: { auth: false }
  },
  {
    path: "/activation",
    name: "Activation",
    component: FormPage,
    meta: { auth: false }
  },
  {
    path: "/article/:id",
    name: "ArticleView",
    component: ArticleView,
    meta: { auth: false, keepAlive: false }
  },
  {
    path: "/@:username/:code/article/:id",
    name: "ArticleViewByBook",
    component: ArticleView,
    meta: { auth: false, keepAlive: false }
  },
  {
    path: "/article/edit/:articleId",
    name: "ArticleEdit",
    component: ArticleEdit,
    meta: { auth: true }
  },
  {
    path: "/forgotPassword",
    name: "ForgotPassword",
    component: FormPage,
    meta: { auth: false }
  },
  {
    path: "/resetPassword/:pe/:pc/:pt",
    name: "ResetPassword",
    component: FormPage,
    meta: { auth: false }
  },
  {
    path: "/auth/:provider",
    name: "Auth",
    component: FormPage,
    meta: { auth: false }
  },
  {
    path: "/auth/callback",
    name: "AuthCallback",
    component: FormPage,
    meta: { auth: false }
  },
  {
    path: "*",
    name: "404",
    component: DefaultPage,
    meta: { auth: false, keepAlive: true }
  },
  {
    path: "/404",
    name: "notFound",
    component: DefaultPage,
    meta: { auth: false, keepAlive: true }
  },
  {
    path: "/admin",
    name: 'adminIndex',
    component: AdminIndex,
    meta: { auth: true, admin: true }
  },
  {
    path: "/event",
    name: "Event",
    component: Event,
    meta: { auth: false }
  },
  {
    path: "/vip/event/create",
    name: "CreateEvent",
    component: CreateEvent,
    meta: { auth: true, vip: true }
  },
  {
    path: "/e/:code",
    name: "EventView",
    component: EventView,
    meta: { auth: false, showHeader: false }
  },
  {
    path: "/event/:eventName/list",
    name: "EventList",
    component: EventList,
    meta: { auth: false, keepAlive: true }
  },
  {
    path: "/event/addArticle/:eventId",
    name: "EventAddArticle",
    component: ArticleEdit,
    meta: { auth: false, keepAlive: false, inEditor: true }
  },
  {
    path: "/event/edit/:eventId",
    name: "EditEvent",
    component: CreateEvent,
    meta: { auth: false, keepAlive: false, vip: true }
  },
  {
    path: "/event/setting/:eventId",
    name: "EventSettings",
    component: EventSettings,
    meta: { auth: false, keepAlive: false, vip: true }
  }

];

const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    return savedPosition;
  } else if (to.name.startsWith("Home")) {
    return null;
  } else {
    const position = { x: 0, y: 0 };
    if (to.hash) {
      position.selector = to.hash;
    }
    return position;
  }
};
const router = new Router({
  mode: "history",
  scrollBehavior,
  base: __dirname,
  routes
});

router.beforeEach(async ({ meta, path, name }, from, next) => {
  let { auth = true, admin, vip } = meta;
  let userInfo, isLogin, isAdmin, isVip
  let authInfo = await store.dispatch('auth')
  if (authInfo && authInfo.userInfo) {
    userInfo = authInfo.userInfo
    isAdmin = userInfo.role == 'admin'
    isVip = userInfo.role == 'vip'
    isLogin = true
  } else {
    isLogin = false
  }

  if (
    isLogin &&
    !userInfo.username &&
    path != "/profile/firstSetting"
  ) {
    return next({ path: "/profile/firstSetting" });
  }
  if (isLogin && (path == "/login" || path == "/reg")) {
    return next({ path: "/index" });
  }
  if (auth && !isLogin && !admin) {
    return next({ path: "/login" });
  }



  if (auth && admin) {
    if (isLogin && isAdmin) {
      return next()
    } else {
      return next({ path: "/index" });
    }
  }
  if (auth && vip) {
    if (isLogin && (isVip || isAdmin)) {
      return next()
    } else {
      return next({ path: "/index" });
    }
  }

  Vue.prototype.$UiLoadingBar({
    size: 2
  });
  next();
});

router.afterEach((to, from) => {
  Vue.prototype.$UiLoadingBar.finish();

  browserTitle(i18n.t(`${to.name}Page`));
});

export default router;
